import { render } from "./KTDatatable.vue?vue&type=template&id=2a769966"
import script from "./KTDatatable.vue?vue&type=script&lang=ts"
export * from "./KTDatatable.vue?vue&type=script&lang=ts"

import "./KTDatatable.vue?vue&type=style&index=0&id=2a769966&lang=scss"
script.render = render

export default script